import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';  
import Navbar from './components/Navbar/navbar';
import Homepage from './components/Homepage/homepage';
import Skills from './components/Skills/skills';
import Projects from './components/Projects/projects';
import Works from './components/Works/works';
import Studies from './components/Studies/studies';
import Footer from './components/Footer/footer';

function App() {
  return (
    <Router>
      <div>
        <Navbar />
        <Routes>  {}
          <Route path="/" element={<Homepage />} />
          <Route path="/skills" element={<Skills />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/works" element={<Works />} />
          <Route path="/studies" element={<Studies />} />
          <Route path="/contact" element={<Footer />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;

